import React, { Component } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import { apiErrorMessage } from "Helpers/ContentValidation";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import LeaderFormFields, {
  bioToText,
  emptyLeader,
  textToBio,
} from "components/ContentForms/LeaderFormFields";

export default class UpdateLeader extends Component {
  state = {
    leaderId: window.location.pathname.split("/")[2],
    values: { ...emptyLeader },
    fetching: true,
    loading: false,
    notification: false,
    notiColor: "success",
    message: "",
    redirect: false,
    signin: false,
  };

  componentDidMount() {
    this.fetchLeader();
  }

  notify = (notiColor, message) => {
    this.setState({ notification: true, notiColor, message });
    setTimeout(() => this.setState({ notification: false, message: "" }), 4000);
  };

  fetchLeader = async () => {
    if (init() !== "success") return this.setState({ signin: true });

    try {
      const response = await axios.get(Constants.getUrls.getLeader + this.state.leaderId);
      const data = response.data?.data || {};
      this.setState({
        fetching: false,
        values: {
          name: data.name || "",
          designation: data.designation || "",
          bio: bioToText(data.bio),
          sort_order: data.sort_order ?? 0,
          status: data.status || "active",
        },
      });
    } catch (error) {
      this.setState({ fetching: false });
      this.notify("warning", apiErrorMessage(error, "Could not load the leader"));
    }
  };

  handleChange = (name, value) =>
    this.setState((prev) => ({ values: { ...prev.values, [name]: value } }));

  handleSubmit = async (e) => {
    e.preventDefault();
    const { values, leaderId } = this.state;

    if (!values.name.trim()) return this.notify("warning", "Name is required!");
    if (init() !== "success") return this.setState({ signin: true });

    this.setState({ loading: true });

    try {
      const response = await axios.put(Constants.putUrls.updateLeader + leaderId, {
        ...values,
        bio: textToBio(values.bio),
      });
      this.notify("success", response.data?.message || "Leader updated!");
      setTimeout(() => this.setState({ redirect: true }), 1500);
    } catch (error) {
      this.setState({ loading: false });
      this.notify("warning", apiErrorMessage(error, "Failed to update leader"));
    }
  };

  render() {
    if (this.state.signin) return <Navigate to="/signin" replace />;
    if (this.state.redirect) return <Navigate to="/leaders" />;

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update Leader
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              {this.state.fetching ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : (
                <form onSubmit={this.handleSubmit}>
                  <LeaderFormFields values={this.state.values} onChange={this.handleChange} />

                  <Grid item sm={12} mt={2}>
                    <MDButton
                      variant="contained"
                      size="small"
                      color="info"
                      type="submit"
                      disabled={this.state.loading}
                    >
                      {this.state.loading ? "Updating..." : "Update"}
                    </MDButton>
                  </Grid>
                </form>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Leadership"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
              close={() => this.setState({ notification: false })}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
